import { Tipo_division } from './../../../models/tipo_division.model';
import { Component } from "@angular/core";
import { FormGroup, FormControl, Validators } from '@angular/forms';


@Component({
    selector: "page-tipo_division",
    templateUrl: "./tipo_division.component.html"
    
})


export class Tipo_divisionComponent {
    public rows = [];
    public actualRow;
    public tipo_division: Tipo_division;
    public form;
    
    constructor(){
        this.form = new FormGroup({
            tipo_division1: new FormControl('', Validators.required),
            tipo_division2:new FormControl('', Validators.required),
            tipo_division3:new FormControl('', Validators.required),
            
        })
        if(!JSON.parse(localStorage.getItem("tipo_division"))){
            localStorage.setItem("tipo_division", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("tipo_division"));
            this.form.controls['tipo_division1'].setValue(this.rows[0]?this.rows[0].subdivision:'NO')
            this.form.controls['tipo_division2'].setValue(this.rows[0]?this.rows[0].fusion:'NO')
            this.form.controls['tipo_division3'].setValue(this.rows[0]?this.rows[0].urbanizacion:'NO')
        }
        this.tipo_division= {subdivision:'',fusion:'',urbanizacion:''}
    }

    add_tipo_division(){
        localStorage.setItem("tipo_division",JSON.stringify([]));
        this.actualRow = localStorage.getItem("tipo_division");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            'subdivision': this.form.value.tipo_division1, 
            'fusion': this.form.value.tipo_division2,
            'urbanizacion': this.form.value.tipo_division3,
        })
        localStorage.setItem("tipo_division", JSON.stringify(this.rows));

    }
  
    delete_tipo_division(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("tipo_division", JSON.stringify(this.rows));
            }
        }
    }   
}